export const customGradients = {
  heroQuickOrder: "linear-gradient(135deg, #0C4A45 0%, #116B64 100%)",
  preparing: "linear-gradient(135deg, #92703F 0%, #6C532A 100%)",
  awaiting: "linear-gradient(135deg, #D24545 0%, #A32E2E 100%)",
  today: "linear-gradient(135deg, #F59E0B 0%, #D24545 100%)",
  // No 0%/100% stops: stylis-plugin-rtl mirrors those and the gradient collapses to one colour.
  instagram: "linear-gradient(45deg, #F58529, #DD2A7B 45%, #8134AF 75%, #515BD4)",
} as const;

export const instagramBrandColor = "#DD2A7B";

export const customShadows = {
  heroQuickOrder: "0 20px 50px -12px rgba(12, 74, 69, 0.35)",
  authCard: "0 30px 70px -20px rgba(27, 36, 70, 0.35)",
  instagram: "0 18px 40px -14px rgba(221, 42, 123, 0.45)",
} as const;
